import React from 'react';

const Community = () => {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-6">Educator Community</h1>
      <p className="text-gray-600">Community features coming soon...</p>
    </div>
  );
};

export default Community;